var getDomain = function () {
    var domain = window.location.hostname;
    if (process.env.NODE_ENV !== "production") {
        var url = new URL(window.location.href);
        domain = url.searchParams.get("domain") || domain;
    }
    return domain || "";
};
export default getDomain;
